module.exports = __webpack_public_path__ + "static/venice20891-d1cb309a996b536bede2f6a73a2ba2ae.png";